import React, { useState, useEffect, useRef } from "react";
import axiosInstance from "../../../../axios";
import { Loading } from "../../../Other/Loading";
import moment from "moment/moment";
import "../CourseList.scss";
import "./memberList.scss";
import { DateRange } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import OverlayContainer from "@components/Overlay/OverlayContainer";
import Forms from "./Forms";
import Pagination from "./Pagination";
import { CourseBuilderStaticData } from "../../../../_constants/staticData";
import { downloadCSV } from "../../../../_helpers";
import AddMenu from "../AddMenu/AddMenu";
import BulkUploadOverlay from "../../Shared/BulkUpload/BulkUploadOverlay";
import Modal from "../../../Other/Modal";
import { FaEdit, FaEye, FaSort, FaTrash } from "react-icons/fa";
import { toast } from "react-toastify";

function MemberList() {
  // State declarations
  const [instructorData, setInstructorData] = useState([]);
  const [instructorStats, setInstructorStats] = useState();
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [instructorId, setInstructorId] = useState(0);
  const [dateRangePicker, setDateRangePicker] = useState(false);
  const [dateToggle, setDateToggle] = useState(false);
  const [editInstructorData, setEditInstructorData] = useState([]);
  const [filter, setFilter] = useState({
    status: "",
    startDate: "",
    endDate: "",
    page: 1,
    itemsPerPage: 10,
  });
  //console.log("filterfilter", filter);
  const [page, setPage] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(false);
  const [addMenu, setAddMenu] = useState(false);
  const [addBulkUsers, setAddBulkUsers] = useState(false);
  const [isUploaded, setIsUploaded] = useState(true);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [showIntroIndexes, setShowIntroIndexes] = useState({});
  const [viewData, setViewData] = useState(null);
  const [editRow, setEditRow] = useState(null);
  //console.log("editRoweditRow", editRow);
  const refOne = useRef(null);

  // Handlers
  const fetch = async () => {
    setLoading(true);

    try {
      const res = await axiosInstance.get(
        `user/teacher?status=${filter.status}&page=${filter.page}&perPage=${filter.itemsPerPage}&startDate=${filter.startDate}&endDate=${filter.endDate}`
      );
      console.log("res", res.data?.data?.data);
      setInstructorData(res.data?.data?.data);
      setPage(res.data.data.total_page);
    } catch (error) {
      console.error("Error fetching instructor data:", error.message);
    } finally {
      setLoading(false);
    }
  };


  const handleLastMonth = () => {
    const now = new Date();
    const startOfLastMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1);
    const endOfLastMonth = new Date(now.getFullYear(), now.getMonth(), 0);

    setFilter({
      ...filter,
      startDate: moment(startOfLastMonth).format("YYYY-MM-D"),
      endDate: moment(endOfLastMonth).format("YYYY-MM-D"),
    });
  };

  const handleSelectChange = (e) => {
    setFilter({ ...filter, itemsPerPage: e.target.value });
  };

  const handleStatusFilter = (e) => {
    setFilter({ ...filter, status: e.target.value });
  };

  const handleDateRangeFilter = (item) => {
    setFilter({
      ...filter,
      startDate: moment(item.selection.startDate).format("YYYY-MM-D"),
      endDate: moment(item.selection.endDate).format("YYYY-MM-D"),
    });
    setRange([item.selection]);
  };

  const deleteInstructor = (UserIds) => {
    setConfirmDelete(true);
    setInstructorId(UserIds);
  };

  const handleDeleteInstructor = async () => {
    try {
      const res = await axiosInstance.post("admin/user/delete/", {
        userId: instructorId,
      });

      if (res) {
        toast.success(res?.data?.message);
        setConfirmDelete(false);
      }
    } catch (error) {
      console.error("Error deleting instructor:", error.message);
      setConfirmDelete(false); // Still close the modal even on error
    }
  };


  const handleEditInstructor = (data) => {
    console.log("data", data);
    setModal(true);
    setEditInstructorData(data);
  };

  const handleAddInstructor = () => {
    setModal(true);
    setEditInstructorData([]);
    setAddMenu(false);
  };

  const handleViewInstructor = (data) => {
    setViewData(data);
  };

  const handleInstructorList = async () => {
    try {
      const res = await axiosInstance.get("/admin/export/instructors");
      downloadCSV(res?.data, "Instructor-list");
    } catch (error) {
      console.error("Error downloading instructor list:", error.message);
      // Optionally: show a toast or alert to the user
    }
  };


  const handleAddBulkUsers = () => {
    setAddBulkUsers(true);
    setAddMenu(false);
  };

  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };

  // Effects
  useEffect(() => {
    const fetchInstructorStats = async () => {
      try {
        const res = await axiosInstance.get("admin/instructor-statistics");
        setInstructorStats(res.data.data);
      } catch (error) {
        console.error("Error fetching instructor statistics:", error.message);
      }
    };

    fetchInstructorStats();
  }, [isUploaded]);


  useEffect(() => {
    fetch();
    document.addEventListener("keydown", hideOnEscape, true);
    document.addEventListener("click", hideOnClickOutside, true);
    return () => {
      document.removeEventListener("keydown", hideOnEscape, true);
      document.removeEventListener("click", hideOnClickOutside, true);
    };
  }, [filter, modal, confirmDelete, isUploaded]);

  // Date picker logic
  const [range, setRange] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ]);

  const hideOnEscape = (e) => {
    if (e.key === "Escape") {
      setDateToggle(false);
    }
  };

  const hideOnClickOutside = (e) => {
    if (refOne.current && !refOne.current.contains(e.target)) {
      setDateToggle(false);
    }
  };

  // Sorting logic
  const sortedData = React.useMemo(() => {
    if (!sortConfig.key) return instructorData;
    const sorted = [...instructorData].sort((a, b) => {
      let aValue = a[sortConfig.key];
      let bValue = b[sortConfig.key];
      if (sortConfig.key === "name") {
        aValue = `${a.firstName} ${a.lastName}`;
        bValue = `${b.firstName} ${b.lastName}`;
      }
      if (typeof aValue === "string" && typeof bValue === "string") {
        return sortConfig.direction === "asc"
          ? aValue.localeCompare(bValue)
          : bValue.localeCompare(aValue);
      }
      if (typeof aValue === "number" && typeof bValue === "number") {
        return sortConfig.direction === "asc"
          ? aValue - bValue
          : bValue - aValue;
      }
      return 0;
    });
    return sorted;
  }, [instructorData, sortConfig]);

  // Static data for dashboard
  const staticData = [
    {
      name: "Total Instructors",
      total: instructorStats?.totalInstructors || "0",
      boxShadow: "Dashboard-color-one",
      color: "color-one",
    },
    {
      name: "Pending Request",
      total: instructorStats?.pendingVerification || "0",
      boxShadow: "Dashboard-color-two",
      color: "color-two",
    },
    {
      name: "Without Course",
      total: instructorStats?.withNotPublishedCourse || "0",
      boxShadow: "Dashboard-color-three",
      color: "color-three",
    },
  ];

  const handleStatusChange = async (userId, currentStatus, role) => {
    //"currentStatus", currentStatus, userId, role);

    const url = currentStatus === 0
      ? "/user/v1/deactive"
      : "/user/v1/reactivate";

    try {
      const token = JSON.parse(localStorage.getItem("token"));
      let response;

      if (currentStatus === 1) {
        response = await axiosInstance.post(
          url,
          { userId, role },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

      } else {
        response = await axiosInstance.put(
          url,
          { userId, role },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      }

      const result = response.data;
      fetch();
      if (!result.error) {
        alert(result.message || "Status updated successfully");
      } else {
        alert(result.message || "Something went wrong");
      }
    } catch (err) {
      console.error(err);
      alert("Error changing status");
    }
  };
  // Render
  return (
    <div className="width-0 member-list-container m-0 p-0">
      {loading ? (
        <Loading />
      ) : (
        <>
          {/* Dashboard Header */}
          <div className="dashboard-container-new">
            <p>Instructor List</p>
            <div>
              <button className="lastmonth-btn" onClick={handleLastMonth}>Last Month</button>
              <button className="export-btn" onClick={handleInstructorList}>
                Export
              </button>
            </div>
          </div>
          {/* Dashboard Stats */}
          <div className="flex-dashboard-new-1">
            {staticData.map((item, index) => (
              <div className={`box-shadow-06 ${item.boxShadow}`} key={index}>
                <p className="font-custom-p">{item.name}</p>
                <p className={`font-increase ${item.color}`}>{item.total}</p>
              </div>
            ))}
          </div>
          {/* Filters and Pagination */}
          <div className="page-data-new">
            <div>
              {instructorData?.length > 0 ? (
                <p className="showing-result">
                  Showing {filter.page} page of {filter.itemsPerPage} results
                </p>
              ) : (
                <p className="showing-result">Showing 0 result</p>
              )}
            </div>
            <div className="pagination-flex">
              <div className="add-btn-container">
                <button
                  onClick={() => setAddMenu((state) => !state)}
                  className="export-btn"
                >
                  Add <span>&#10009;</span>
                </button>
                {addMenu && (
                  <AddMenu
                    setAddMenu={setAddMenu}
                    handleAddBulkUsers={handleAddBulkUsers}
                    handleAddUser={handleAddInstructor}
                    role={1}
                  />
                )}
              </div>
              <div className="pagination-date">
                {dateRangePicker === false ? (
                  <input
                    type="text"
                    placeholder="Date Range"
                    className="date-ranger-instructor"
                    onClick={() => {
                      setDateRangePicker(true);
                      setDateToggle(true);
                    }}
                  />
                ) : (
                  <input
                    type="text"
                    value={`${moment(range[0].startDate).format(
                      "MM/DD/YYYY"
                    )} to ${moment(range[0].endDate).format("MM/DD/YYYY")}`}
                    placeholder="Date Range"
                    className="date-ranger-instructor-updated"
                    onClick={() => setDateToggle(true)}
                  />
                )}
                <div className="dateWrap" ref={refOne}>
                  {dateToggle && (
                    <DateRange
                      onChange={(item) => handleDateRangeFilter(item)}
                      editableDateInputs={true}
                      moveRangeOnFirstSelection={false}
                      ranges={range}
                      months={1}
                      direction="horizontal"
                      className="dateElement"
                    />
                  )}
                </div>
              </div>
              <div className="pagination-select">
                <select
                  className="select-dropdown-instructor-2 px-5"
                  onChange={handleStatusFilter}
                >
                  <option value="">Select Status</option>
                  <option value="0">Pending</option>
                  <option value="1">Completed</option>
                </select>
              </div>
              <div className="flex-items-per-page">
                <p className="item-page-result">Item per page</p>
                <div className="pagination-select">
                  <select
                    className="select-dropdown-instructor-1"
                    onChange={handleSelectChange}
                    value={filter.itemsPerPage}
                  >
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={30}>30</option>
                    <option value={40}>40</option>
                    <option value={50}>50</option>
                  </select>
                </div>
              </div>
              <div>
                <button
                  className="clear-btn"
                  onClick={() => {
                    setFilter({
                      ...filter,
                      status: "",
                      startDate: "",
                      endDate: "",
                      page: 1,
                    });
                    setRange([{
                      startDate: new Date(),
                      endDate: new Date(),
                      key: "selection",
                    }]);
                  }}
                >
                  Clear
                </button>
              </div>
            </div>
          </div>
          {/* Table */}
          <div className="instructor-table">
            {instructorData?.length === 0 ? (
              <h2 className="no-data-found">No data found</h2>
            ) : (
              <table className="table-width-100">
                <thead>
                  <tr className="cursor-pointer ">
                    <th onClick={() => handleSort("srno")}>
                      <div className="flex items-center gap-1">
                        Sr.no{" "}
                        {sortConfig.key === "srno"
                          ? sortConfig.direction === "asc"
                            ? "▲"
                            : "▼"
                          : <FaSort className="text-gray-400" />}
                      </div>
                    </th>
                    <th onClick={() => handleSort("name")}>
                      <div className="flex items-center gap-1">
                        Name{" "}
                        {sortConfig.key === "name"
                          ? sortConfig.direction === "asc"
                            ? "▲"
                            : "▼"
                          : <FaSort className="text-gray-400" />}
                      </div>
                    </th>
                    <th onClick={() => handleSort("userName")}>
                      <div className="flex items-center gap-1">
                        User Name{" "}
                        {sortConfig.key === "userName"
                          ? sortConfig.direction === "asc"
                            ? "▲"
                            : "▼"
                          : <FaSort className="text-gray-400" />}
                      </div>
                    </th>
                    <th onClick={() => handleSort("introduction")}>
                      <div className="flex items-center gap-1">
                        Cousre List{" "}
                        {sortConfig.key === "introduction"
                          ? sortConfig.direction === "asc"
                            ? "▲"
                            : "▼"
                          : <FaSort className="text-gray-400" />}
                      </div>
                    </th>
                    <th onClick={() => handleSort("email")}>
                      <div className="flex items-center gap-1">
                        Email ID{" "}
                        {sortConfig.key === "email"
                          ? sortConfig.direction === "asc"
                            ? "▲"
                            : "▼"
                          : <FaSort className="text-gray-400" />}
                      </div>
                    </th>
                    <th onClick={() => handleSort("phoneNumber")}>
                      <div className="flex items-center gap-1">
                        Phone Number{" "}
                        {sortConfig.key === "phoneNumber"
                          ? sortConfig.direction === "asc"
                            ? "▲"
                            : "▼"
                          : <FaSort className="text-gray-400" />}
                      </div>
                    </th>
                    <th onClick={() => handleSort("country")}>
                      <div className="flex items-center gap-1">
                        Country{" "}
                        {sortConfig.key === "country"
                          ? sortConfig.direction === "asc"
                            ? "▲"
                            : "▼"
                          : <FaSort className="text-gray-400" />}
                      </div>
                    </th>
                    {/* <th onClick={() => handleSort("createdAt")}>
                      <div className="flex items-center gap-1">
                        Register Date{" "}
                        {sortConfig.key === "createdAt"
                          ? sortConfig.direction === "asc"
                            ? "▲"
                            : "▼"
                          : <FaSort className="text-gray-400" />}
                      </div>
                    </th> */}
                    <th onClick={() => handleSort("status")}>
                      <div className="flex items-center gap-1">
                        Status{" "}
                        {sortConfig.key === "status"
                          ? sortConfig.direction === "asc"
                            ? "▲"
                            : "▼"
                          : <FaSort className="text-gray-400" />}
                      </div>
                    </th>
                    <th>action</th>
                  </tr>
                </thead>
                <tbody>
                  {sortedData?.length > 0 ? (
                    sortedData?.map((ele, index) => (
                      <tr key={index}>
                        <td className="cell">
                          {filter?.itemsPerPage * filter?.page -
                            filter?.itemsPerPage +
                            index +
                            1}
                        </td>
                        <td className="cell">
                          <div>
                            {ele?.profileImage ? (
                              <img alt="Profile" src={ele?.profileImage} className="avatar-profile-image-02" />
                            ) : (
                              ele && <span className="avatar-placeholder">{ele?.firstName.charAt(0)}</span>
                            )}
                            <p>{ele.firstName + " " + ele.lastName}</p>
                          </div>
                        </td>
                        <td className="cell">{ele.userName}</td>
                        <td className="cell">
                          {(() => {
                            let introArr = [];
                            try {
                              introArr = ele?.introduction && Array.isArray(JSON.parse(ele?.introduction))
                                ? JSON.parse(ele?.introduction)
                                : [];
                            } catch {
                              introArr = [];
                            }
                            const showAll = showIntroIndexes[index];
                            if (introArr?.length === 0) {
                              return <span className="no-data-text">No data</span>;
                            }
                            return (
                              <>
                                {showAll
                                  ? introArr.map((item, idx) => (
                                    <p key={idx}>{item}</p>
                                  ))
                                  : (
                                    <p>{introArr[0]}</p>
                                  )
                                }
                              </>
                            );
                          })()}
                        </td>
                        <td className="cell">{ele.email}</td>
                        <td className="cell">{ele.phoneNumber}</td>
                        <td className="cell">{ele.userCountryCode || "-"}</td>
                        {/* <td className="cell">
                          {ele.createdAt
                            ? moment(ele?.createdAt).format("DD/MM/YYYY")
                            : "01/12/22"}
                        </td> */}
                        <td className="cell">
                          {editRow === index ? (
                            <select
                              value={ele.status}
                              onChange={(e) => {
                                handleStatusChange(ele.userIds, Number(e.target.value), ele.role);
                                setEditRow(null);
                              }}
                              onBlur={() => setEditRow(null)}
                              className="status-select"
                            >
                              <option value={1}>Active</option>
                              <option value={0}>Inactive</option>
                            </select>
                          ) : (
                            <span
                              onClick={() => setEditRow(index)}
                              className={`status-badge ${ele.status ? "completed" : "pending"}`}
                            >
                              {ele.status ? "Completed" : "Pending"}
                            </span>
                          )}
                        </td>
                        <td className="cell flex items-center gap-2 !mt-[14px]">
                          <FaEye
                            className="action-icon"
                            title="View"
                            onClick={() => handleViewInstructor(ele)}
                          />
                          <FaEdit
                            className="action-icon"
                            title="Edit"
                            onClick={() => handleEditInstructor(ele)}
                          />
                          <FaTrash
                            className="action-icon"
                            title="Delete"
                            onClick={() => deleteInstructor(ele.userIds)}
                          />
                        </td>
                      </tr>
                    ))
                  ) : (
                    <h2 className="no-data-found">No data found</h2>
                  )}
                </tbody>
              </table>
            )}
            {confirmDelete === true && (
              <Modal
                isOpen={confirmDelete}
                onClose={() => setConfirmDelete(false)}
              >
                <div className="alert-dialog-inner">
                  <div className="alert-title">Warning!</div>
                  <div className="alert-message">
                    {CourseBuilderStaticData.deleteInstructorOverlay.header}
                  </div>
                  <div className="alert-close-btn">
                    <a className="btn-save" onClick={handleDeleteInstructor}>
                      OK
                    </a>
                    <a
                      className="btn-cancel"
                      onClick={() => setConfirmDelete(false)}
                    >
                      CANCEL
                    </a>
                  </div>
                </div>
              </Modal>
            )}
          </div>
          {/* Pagination */}
          <div className="pageNumbers-sudents">
            {instructorData?.length >= 0 ? (
              <Pagination
                className="pageNumbers-sudents"
                currentPage={filter.page}
                totalCount={filter.itemsPerPage}
                pageSize={page}
                onPageChange={(page) => setFilter({ ...filter, page: page })}
              />
            ) : (
              ""
            )}{" "}
          </div>
          {/* Modals */}
          {modal && (
            <Modal isOpen={modal} onClose={() => setModal(false)}>
              <Forms
                setModal={setModal}
                title="Instructor"
                role="Instructor"
                editData={editInstructorData}
              />
            </Modal>
          )}
          {addBulkUsers && (
            <Modal isOpen={addBulkUsers} onClose={() => setAddBulkUsers(false)}>
              <BulkUploadOverlay
                onCancel={() => setAddBulkUsers(false)}
                role={4}
                setIsUploaded={setIsUploaded}
              />
            </Modal>
          )}
          {viewData && (
            <Modal isOpen={!!viewData} onClose={() => setViewData(null)}>
              <div className="w-full p-4">
                <div className="modal-details-header mb-5">
                  Instructor Details
                </div>
                <div className="modal-details-body">
                  {/* Profile Section */}
                  <div className="flex items-center gap-6 mb-8">
                    {viewData.profileImage ? (
                      <img
                        src={viewData.profileImage}
                        alt="Profile"
                        className="w-24 h-24 rounded-full object-cover shadow-md"
                      />
                    ) : (
                      <div className="w-24 h-24 rounded-full bg-gray-200 text-gray-700 flex items-center justify-center text-3xl font-bold shadow-sm">
                        {viewData.firstName?.charAt(0)}
                      </div>
                    )}
                    <div>
                      <h2 className="text-xl font-bold">
                        {viewData.firstName} {viewData.lastName}
                      </h2>
                      <p className="text-gray-500">@{viewData.userName}</p>
                    </div>
                  </div>

                  {/* Details Grid */}
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                    <div>
                      <p className="text-sm text-gray-400 uppercase">Email</p>
                      <p className="text-lg font-medium">{viewData.email}</p>
                    </div>
                    <div>
                      <p className="text-sm text-gray-400 uppercase">Phone</p>
                      <p className="text-lg font-medium">{viewData.phoneNumber}</p>
                    </div>
                    <div>
                      <p className="text-sm text-gray-400 uppercase">Country</p>
                      <p className="text-lg font-medium">{viewData.userCountryCode}</p>
                    </div>
                    <div>
                      <p className="text-sm text-gray-400 uppercase">Registered On</p>
                      <p className="text-lg font-medium">
                        {viewData.createdAt
                          ? moment(viewData.createdAt).format("DD/MM/YYYY")
                          : ""}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="mt-6">
                  <p className="font-bold mb-2 text-gray-700">Course List</p>
                  <div className="flex flex-wrap gap-2">
                    {(() => {
                      let introArr = [];
                      try {
                        introArr =
                          viewData.introduction &&
                            Array.isArray(JSON.parse(viewData.introduction))
                            ? JSON.parse(viewData.introduction)
                            : [];
                      } catch {
                        introArr = [];
                      }
                      return introArr.length > 0 ? (
                        introArr.map((item, idx) => (
                          <span
                            key={idx}
                            className="course-badge"
                          >
                            {item}
                          </span>
                        ))
                      ) : (
                        <span className="text-gray-500">No data</span>
                      );
                    })()}
                  </div>
                </div>
              </div>
            </Modal>
          )}
        </>
      )}
    </div>
  );
}

export default MemberList;
